//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapActions,
  mapState
} from 'vuex';
import axios from 'axios';

export default {
  name: 'App',
  computed: {//themeFlag:happyRed 科技红；blackGold 黑金；technologyBlue 科技蓝
    ...mapState(["shoppingCartQty", "cid", "isscan", 'themeFlag', 'adImg', 'isHasLoading'])
  },
  data() {
    return {
      sessionKey: !!window.app_userManage ? window.app_userManage.getUserInfo_fromLocalStorage(_SESSION_KEY) : null,
      isCloseBrowser: false, //是否关闭浏览器
      // themeFlag: 'happyRed', 
    }
  },
  watch: {
    isscan(newIsscan, old) {
      this.handleIsscan()
    },
  },
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    ...mapActions(["getScanConfigList", "getSysConfigList", "getOpenPurchaseConfig", "getGetsellerCompanyInfo", "getShoppingCartQty", "getCompanyBriefInfo", 'getThemeConfig']),
    init() {
      let self = this
      /*获取商户相关信息*/
      this.getCompanyBriefInfo()
      this.$store.state.permissions = this.getPermissions()
      this.getScanConfigList().then(({isscan, isscanprice}) => {
        if (isscan) {
          self.getGetsellerCompanyInfo()
          self.getSysConfigList()
          self.getShoppingCartQty()
        } else {
          if (!!self.sessionKey) {
            self.getGetsellerCompanyInfo()
            self.getSysConfigList()
            self.getShoppingCartQty()
          }
        }
      })
      this.getOpenPurchaseConfig()
      if (!this.$store.state.isFirstEnter) {
        this.getThemeConfig()
      }
    },
    /*处理是否开启了商城注册*/
    handleIsscan() {
      this.tabbarChange(0)
    },
    /*切换tabbar*/
    tabbarChange(value) {
      let time = new Date().getTime();
      let cid = this.cid
      switch (value) { //切换tabbar route.fullPath几率混乱
        case 0:
          let url = getTopUrl()
          // 防止第一次进入加载两次
          if (url.indexOf("/index") == -1 || url.indexOf("/index") != -1 && url.indexOf("/index/") != -1) {
            this.$router.push(`/index?cid=${cid}&time=${time}`)
          } else {
            if (this.isscan) { //开放了注册
              if (this.$store.state.isFirstEnter) {
                let self = this
                setTimeout(() => {
                  self.$router.push(`/index?cid=${cid}&time=${time}`)
                }, 1000)
              }
            }
          }
          break;
        case 1:
          this.$router.push(`/sort?cid=${cid}&time=${time}`)
          break;
        case 2:
          if (this.getPermissions(true) < 2) { //如果需要判断权限
            return;
          }
          this.$router.push(`/shoppingcart?cid=${cid}&time=${time}`)
          break;
        case 3:
          this.$router.push(`/my?cid=${cid}&time=${time}`)
          // this.$store.state.pathArr.unshift(`/my?cid=${cid}&time=${time}`)
          break;
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/App.vue